export const adminOnlyLabelFiltersEnum = {
  // When adding labels, the need to be in alphabetical order here as we don't sort them later.
  // These are always last
  falsePositive: 'false_positive',
  duplicate: 'duplicate',
  unknown: 'unknown',
};

export const generalLabelFiltersEnum = {
  commercialTruck: 'commercial_truck',
  humanGathering: 'Human Gathering',
  mechanicalEquipment: ['mechanical_equipment', 'Mechanical Equipment'],
  movable: 'movable',
  oversizedPassengerVehicle: 'oversized_passenger_vehicle',
  personalProperty: 'personal_property',
  potentialLeak: 'Potential Leak',
  regularPassengerVehicle: 'regular_passenger_vehicle',
  // HIDING ALL DETECTIONS OF THIS TYPE FOR THE TIME BEING.
  // ASKED BY ANDREW ON JULY 30th 2022
  // recreationalOffroadVehicle: 'recreational_offroad_vehicle',
  structure: ['structure', 'Structure'],
  temporaryStructure: 'Temporary Structure',
  unidentifiedObject: 'Unidentified Object',
  exposedPipe: 'exposed_pipes',
  tileDrainage: 'tile_drainage',
};

export const allLabelFiltersEnum = { ...generalLabelFiltersEnum, ...adminOnlyLabelFiltersEnum };

export default { adminOnlyLabelFiltersEnum, generalLabelFiltersEnum, allLabelFiltersEnum };
